import { Button } from 'antd';
import { HomeOutlined, MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuthStore } from '../store/authStore';
import { getDefaultRouteForRole } from '../utils/permissions';
import { MarketingLayout } from './marketing/MarketingLayout';

/**
 * 404 page for any unknown URL. prerender.mjs renders it to dist/not-found.html and the
 * Cloudflare worker serves that with a real 404 status. Signed-in users are offered
 * their dashboard instead of the homepage.
 */
export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
  const homeRoute = isAuthenticated && user ? getDefaultRouteForRole(user.role) : '/';

  return (
    <MarketingLayout current="">
      <Helmet>
        <title>Page Not Found | Rongeka Africa</title>
        <meta name="description" content="The page you are looking for does not exist or has moved." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <header className="mkt-hero mkt-error">
        <div className="mkt-error-code" aria-hidden="true">404</div>
        <h1 className="mkt-hero-title">We couldn't find that page</h1>
        <p className="mkt-hero-lead">
          The link may be broken, or the page may have moved. Check the address, or head
          back and find what you need from there.
        </p>
        <div className="mkt-hero-actions">
          <Button type="primary" size="large" icon={<HomeOutlined />} onClick={() => navigate(homeRoute)}>
            {homeRoute === '/' ? 'Back to Home' : 'Go to Your Dashboard'}
          </Button>
          <Button size="large" icon={<MessageOutlined />} onClick={() => navigate('/contact')}>
            Contact Support
          </Button>
        </div>
      </header>
    </MarketingLayout>
  );
};
